import $ from 'jquery'

export default {
    name: 'manage-bon-consultation',
    components: {},
    props: {
        selected_consumable: Object,
        consumable_to_delete: Object
    },
    data() {
        return {
            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: [],

            consumable_item: {
                designation: '',
                price: ''
            },
            save_conso_loading: false,
            modal_title: 'Nouveau consommable de consultation',
            item_is_exist: false,

            
			is_confirm: false,
			del_loading: false,
        }
    },

    watch: {
        selected_consumable() {
            this.consumable_item = {
                designation: this.selected_consumable.consumable_item,
                price: this.selected_consumable.consumable_price
            }

            this.selected_consumable.type_consultations.forEach((el) => {
                this.one_is_checked.push(el.type_consultation_id)
            });

            if (this.selected_consumable.consumable_id == 0) {
                this.modal_title = 'Nouveau consommable de consultation'
                this.one_is_checked = []
            } else {
                this.modal_title = 'Modifier consommable de consultation'
            }
        }
    },

    computed: {
        list_consultations() {
            return this.$store.getters["list_consultations"];
        },
    },

    mounted() {

    },

    methods: {
        toutSelectionner() {
            let is_checked = $('#consult-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.list_consultations.forEach((data) => {
                    
                    this.text_grey[i] = 'text-grey'

                    this.one_is_checked.push(data.id)

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.list_consultations.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            let is_checked = $('#consult'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("consult-tous").checked = false;
        },

        async saveConsumable() {
            const isValid = await this.$refs.consumable_form.validate();

            if (!isValid) {
                return;
            }


            this.save_conso_loading = true

            let  data = {
                consumable_id: this.selected_consumable.consumable_id,
                consumable: this.consumable_item,
                type_consultations: this.one_is_checked
            }
            
            this.$store.dispatch('saveConsumableOfConsultation', data).then((response) => {
                if (response > 0) {
                    this.$emit('emitConsumable')

                    this.$refs.consumable_form.reset()
                    this.$refs.modal_consumable.click()

                    this.consumable_item = {
                        designation: '',
                        price: ''
                    }
                    this.one_is_checked = []
                } else {
                    if (response == -1) {
                        // Item already exist
                        this.item_is_exist = true
                    }
                }

                this.save_conso_loading = false
            })
        },

        clearError() {
            this.item_is_exist = false
        },

        

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteConsumableOfConsultation', this.consumable_to_delete).then((response) => {
                if (response > 0) {
                    this.successToast("Consommable de bon de consultation supprimé avec succès")
                    this.$emit('emitConsumable')

                    this.is_confirm = false
                    this.$refs.del_consumable.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },
    }
}


